import { RefObject } from 'react';

export const resetScrollPosition = (element: HTMLDivElement | null) => {
  if (element) {
    element.scrollTop = 0;
  }
};

export const resetHomeFilterBarScrollPositions = (
  gridScrollRef: RefObject<HTMLDivElement | null>,
  listScrollRef: RefObject<HTMLDivElement | null>
) => {
  resetScrollPosition(gridScrollRef.current);
  resetScrollPosition(listScrollRef.current);
};

export const getActiveHomeScrollElement = (
  displayMode: string,
  gridScrollRef: RefObject<HTMLDivElement | null>,
  listScrollRef: RefObject<HTMLDivElement | null>
) => (displayMode === 'grid' ? gridScrollRef.current : listScrollRef.current);

export const toggleHomeFilterBarState = (isOpen: boolean) => !isOpen;
